module.exports = __webpack_public_path__ + "static/media/menu-home.86f77c06.svg";